import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { id: "Menu_Strip" }
const _hoisted_2 = { class: "position-absolute w-100 d-none d-md-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down ms-1" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 1,
  class: "px-2 text-white account-name"
}
const _hoisted_5 = { class: "ms-auto d-flex z-2" }
const _hoisted_6 = {
  key: 0,
  class: "btn text-white strip-item d-flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check menu-text" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "Axxess Planner", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "px-2 text-white strip-item dropdown app-menu" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-white dropdown-toggle",
  href: "javascript:void(0);",
  id: "User_Dropdown",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-user-circle menu-text" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "My Account")
], -1 /* HOISTED */)
const _hoisted_12 = {
  class: "dropdown-menu dropdown-menu-end mt-0",
  "aria-labelledby": "User_Dropdown"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user me-1" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Profile ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt me-1" }, null, -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Log Out ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  class: "navbar navbar-expand-lg border border-gray p-0",
  id: "App_Navbar"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand d-flex flex-column justify-content-center",
  id: "Brand_Logo"
}, [
  /*#__PURE__*/_createCommentVNode(" INFO: Logo is added as a background to avoid a Chrome rendering issue "),
  /*#__PURE__*/_createElementVNode("span", { class: "logo" })
], -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler text-white",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#App_Menu",
  "aria-controls": "App_Menu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars me-2" })
], -1 /* HOISTED */)
const _hoisted_23 = {
  class: "collapse navbar-collapse",
  id: "App_Menu"
}
const _hoisted_24 = {
  class: "navbar-nav me-auto h-lg-100",
  id: "App__MainMenu"
}
const _hoisted_25 = ["id"]
const _hoisted_26 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_27 = ["id"]
const _hoisted_28 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_31 = ["aria-labelledby"]
const _hoisted_32 = ["data-bs-toggle", "rel", "onClick"]
const _hoisted_33 = { class: "nav-item dropdown app-menu" }
const _hoisted_34 = {
  class: "nav-link dropdown-toggle d-none d-lg-inline-block",
  href: "javascript:void(0);",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-life-ring" }, null, -1 /* HOISTED */)
const _hoisted_36 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_37 = {
  class: "nav-link dropdown-toggle d-lg-none",
  "data-bs-toggle": "dropdown",
  href: "javascript:void(0);",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-life-ring" }, null, -1 /* HOISTED */)
const _hoisted_39 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_40 = { class: "dropdown-menu" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "https://community.axxessweb.com/",
  rel: "noopener noreferrer",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "User Community")
], -1 /* HOISTED */)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "https://www.axxess.com/help/",
  rel: "noopener noreferrer",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Help Center")
], -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "Support Key", -1 /* HOISTED */)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  class: "navbar-nav",
  id: "App__MenuRight"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-search" }, null, -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-center ps-1" }, "Employees", -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-search" }, null, -1 /* HOISTED */)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-center ps-1" }, "Patients", -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagesPreview = _resolveComponent("MessagesPreview")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (_ctx.organizations?.length > 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "px-2 text-white account-name",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeOrganization && _ctx.changeOrganization(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.organizationName) + " ", 1 /* TEXT */),
              _hoisted_3
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.organizationName), 1 /* TEXT */))
      ]),
      _createElementVNode("section", _hoisted_5, [
        (_ctx.isConnectEnabled)
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
              _createVNode(_component_MessagesPreview, { "is-axxess-planner-header": _ctx.isAxxessPlannerHeader }, null, 8 /* PROPS */, ["is-axxess-planner-header"]),
              _createElementVNode("span", {
                class: "d-none d-md-inline ms-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToAxxessChat()))
              }, "Axxess Connect")
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          class: "btn text-white strip-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToAxxessCentral()))
        }, _hoisted_9),
        _createElementVNode("span", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirectToProfile()))
            }, _hoisted_15),
            _hoisted_16,
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logout()))
            }, _hoisted_19)
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_20, [
      _createCommentVNode(" Logo "),
      _hoisted_21,
      _createCommentVNode(" Small screen - burger icon menu "),
      _hoisted_22,
      _createCommentVNode(" App Menu"),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("ul", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayRoutes, (route) => {
            return (_openBlock(), _createElementBlock("li", {
              key: route,
              class: _normalizeClass(`nav-item ${_ctx.isActivePath(route.path) ? 'active' : ''} dropdown app-menu`)
            }, [
              _createCommentVNode(" MENU ICON AND NAME "),
              _createCommentVNode(" INFO: data-bs-toggle=\"dropdown\" is not used to avoid default click behavior "),
              (route.children)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "nav-link dropdown-toggle h-100 d-none d-lg-inline-block",
                    href: "javascript:void(0);",
                    onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeNotifications())),
                    id: `MainMenu__${route.name}`,
                    role: "button",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(route.meta.iconClass),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    (!_ctx.isSearchExpanded)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(route.meta.menuName), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_25))
                : _createCommentVNode("v-if", true),
              (route.children)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "nav-link dropdown-toggle d-lg-none",
                    "data-bs-toggle": "dropdown",
                    href: "javascript:void(0);",
                    id: `MainMenu__${route.name}`,
                    role: "button",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(route.meta.iconClass)
                    }, null, 2 /* CLASS */),
                    (!_ctx.isSearchExpanded)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(route.meta.menuName), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_27))
                : _createCommentVNode("v-if", true),
              (!route.children)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "nav-link",
                    href: route.href,
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#App_Menu"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(route.meta.iconClass)
                    }, null, 2 /* CLASS */),
                    (!_ctx.isSearchExpanded)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(route.meta.menuName), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_29))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" SUB-MENU "),
              _createElementVNode("div", {
                class: "dropdown-menu",
                "aria-labelledby": `MainMenu__${route.name}`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (subRoute) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: subRoute,
                    class: "p-0 m-0"
                  }, [
                    _withDirectives(_createElementVNode("a", {
                      class: _normalizeClass(`dropdown-item ${_ctx.isActivePath(route.path) ? 'active' : ''}`),
                      "data-bs-toggle": `${subRoute.meta && subRoute.path ? '' : 'collapse'}`,
                      "data-bs-target": "#App_Menu",
                      rel: `${subRoute.meta && subRoute.path ? 'noopener noreferrer' : ''}`,
                      onClick: ($event: any) => (_ctx.goToRoute(subRoute.path))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(subRoute.meta.menuName), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_32), [
                      [_vShow, _ctx.showRoute(subRoute.meta.navItem) && subRoute.meta?.showInLevelTwoNav !== false]
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_31)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("li", _hoisted_33, [
            _createElementVNode("a", _hoisted_34, [
              _hoisted_35,
              (!_ctx.isSearchExpanded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Help"))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("a", _hoisted_37, [
              _hoisted_38,
              (!_ctx.isSearchExpanded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Help"))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" SUB-MENU "),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _hoisted_42,
              (_ctx.liveLoginData)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "dropdown-item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayLiveLoginToken()))
                  }, _hoisted_44))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createCommentVNode(" Right Nav "),
        _createElementVNode("ul", _hoisted_45, [
          _createElementVNode("li", null, [
            (_ctx.showEmployeeSearch)
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["nav-link", _ctx.showEmployees ? 'selected' : '']),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleEmployeesMenus()))
                }, _hoisted_48, 2 /* CLASS */)), [
                  [_directive_tooltip, { title: _ctx.employeesTooltip, placement: 'bottom' }]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["nav-link", _ctx.showPatients ? 'selected' : '']),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.togglePatientsMenu()))
            }, _hoisted_51, 2 /* CLASS */)), [
              [_directive_tooltip, { title: _ctx.patientsTooltip, placement: 'bottom' }]
            ])
          ])
        ]),
        _createCommentVNode(" Left Nav ")
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}